import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Popconfirm, message, Tooltip, Modal, Alert } from "antd";
import {
  StopOutlined,
  CheckCircleOutlined,
  ImportOutlined,
  UsergroupAddOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import {
  ButtonItem,
  SegmentedItem,
  TableItemDinamico,
  SelectEscuelasItem,
} from "../../../../Components/Items";
import SelectGruposEscuelaItem from "../../../../Components/SelectGruposEscuelaItem";
import SelectListasEscuelaItem from "../../../../Components/SelectListasEscuelaItem";
import AlumnoModal from "../AlumnoModal/AlumnoModal";

class AlumnosTab extends Component {
  tableRef = null;
  state = {
    todosAlumnos: [],
    loading: false,
    valor: 1,
    totalRecords: 0,
    escuelaFiltro: undefined,
    grupoFiltro: undefined,
    modalVisible: false,
    modalListaVisible: false,
    seleccionClienteIds: [],
    listaSeleccionadaId: undefined,
    listaSeleccionadaNombre: "",
    asignandoLista: false,
  };

  consultarAlumnos = (params) => {
    this.setState({ loading: true });
    axios
      .post(
        "alumnos/selectTodosAlumnos",
        {
          empresaId: this.props.empresaId,
          escuelaId: this.state.escuelaFiltro,
          grupoEscuelaId: this.state.grupoFiltro,
          ...params,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todosAlumnos: res.data.data,
            totalRecords: res.data.totalRecords || 0,
            loading: false,
          });
        } else {
          this.setState({ todosAlumnos: [], totalRecords: 0, loading: false });
        }
      });
  };

  recargar = () => {
    if (this.tableRef)
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
  };

  cambiarEscuela = (escuelaId) => {
    this.setState({ escuelaFiltro: escuelaId, grupoFiltro: undefined, seleccionClienteIds: [] }, this.recargar);
  };
  cambiarGrupo = (grupoId) => {
    this.setState({ grupoFiltro: grupoId }, this.recargar);
  };

  cerrarModal = (recargar = false) => {
    this.setState({ modalVisible: false });
    if (recargar) this.recargar();
  };

  abrirModalLista = () => {
    if (!this.state.seleccionClienteIds.length) {
      message.warning("Selecciona al menos un alumno en la tabla");
      return;
    }
    this.setState({
      modalListaVisible: true,
      listaSeleccionadaId: undefined,
      listaSeleccionadaNombre: "",
    });
  };

  cerrarModalLista = () => {
    this.setState({ modalListaVisible: false });
  };

  confirmarAsignarListaMasiva = () => {
    const { seleccionClienteIds, listaSeleccionadaId, listaSeleccionadaNombre } = this.state;
    if (!listaSeleccionadaId) {
      message.warning("Selecciona la lista a asignar");
      return;
    }
    Modal.confirm({
      title: "¿Asignar lista a los alumnos seleccionados?",
      content: `Se asignará la lista "${listaSeleccionadaNombre}" a ${seleccionClienteIds.length} alumno(s) seleccionado(s). Esto sobrescribirá la lista individual que ya tuvieran asignada.`,
      okText: "Sí, asignar",
      okButtonProps: { danger: true },
      cancelText: "Cancelar",
      centered: true,
      onOk: () => this.asignarListaMasiva(),
    });
  };

  asignarListaMasiva = () => {
    const { escuelaFiltro, listaSeleccionadaId, seleccionClienteIds } = this.state;
    this.setState({ asignandoLista: true });
    axios
      .post(
        "alumnos/asignarListaMasiva",
        {
          empresaId: this.props.empresaId,
          escuelaId: escuelaFiltro,
          listaId: listaSeleccionadaId,
          clienteIds: seleccionClienteIds,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success(`Lista asignada a ${res.data.totalAfectados} alumno(s)`);
          this.setState({ modalListaVisible: false, seleccionClienteIds: [] });
          this.recargar();
        } else {
          message.error(res.data.message || "No se pudo asignar la lista");
        }
      })
      .catch(() => message.error("Error al asignar la lista"))
      .finally(() => this.setState({ asignandoLista: false }));
  };

  cambiarEstadoAlumno = (clienteId, deshabilitar) => {
    const url = deshabilitar
      ? "clientes/deshabilitarCliente"
      : "clientes/habilitarCliente";
    axios
      .post(
        url,
        { clienteId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success(deshabilitar ? "Alumno deshabilitado" : "Alumno habilitado");
        } else {
          message.error("No se pudo cambiar el estado");
        }
        this.recargar();
      });
  };

  render() {
    const columns = [
      { title: "Matrícula", dataIndex: "matricula", key: "matricula", buscar: "matricula", width: 130 },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        buscar: "nombre",
        render: (_, r) =>
          `${r.nombre || ""} ${r.apellidoPaterno || ""} ${r.apellidoMaterno || ""}`.trim(),
      },
      { title: "Escuela", dataIndex: "escuelaNombre", key: "escuelaNombre", ellipsis: true },
      { title: "Grupo", dataIndex: "grupoEscuelaNombre", key: "grupoEscuelaNombre", ellipsis: true, render: (v) => v || "—" },
      { title: "Lista Individual", dataIndex: "listaIndividualNombre", key: "listaIndividualNombre", buscar: "listaIndividualNombre", ellipsis: true, render: (v) => v || "—" },
      { title: "Nivel Prepa", dataIndex: "nivelPrepare", key: "nivelPrepare", width: 110 },
      { title: "Nivel Inglés", dataIndex: "nivelIngles", key: "nivelIngles", align: "center", width: 100, render: (v) => (v == null ? "—" : v) },
      { title: "Correo", dataIndex: "correo", key: "correo", ellipsis: true },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "12%",
        onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
        render: (value) => (
          <div className="acciones-container">
            {value.estado === 1 ? (
              <Popconfirm
                title="¿Deshabilitar este alumno?"
                onConfirm={() => this.cambiarEstadoAlumno(value._id, true)}
                okText="Si"
                cancelText="No"
                disabled={!this.props.permisoDeshabilitarAlumno}
              >
                <Tooltip title={this.props.permisoDeshabilitarAlumno ? "Deshabilitar Alumno" : "No disponible"}>
                  <ButtonItem size="small" lima icon={<CheckCircleOutlined />} disabled={!this.props.permisoDeshabilitarAlumno} />
                </Tooltip>
              </Popconfirm>
            ) : (
              <Popconfirm
                title="¿Habilitar este alumno?"
                onConfirm={() => this.cambiarEstadoAlumno(value._id, false)}
                okText="Si"
                cancelText="No"
                disabled={!this.props.permisoDeshabilitarAlumno}
              >
                <Tooltip title={this.props.permisoDeshabilitarAlumno ? "Habilitar Alumno" : "No disponible"}>
                  <ButtonItem size="small" rojo icon={<StopOutlined />} disabled={!this.props.permisoDeshabilitarAlumno} />
                </Tooltip>
              </Popconfirm>
            )}
          </div>
        ),
      },
    ];

    return (
      <>
        <div
          style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 10,
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", gap: 8, flex: 1, minWidth: 400 }}>
            <div style={{ flex: 1, minWidth: 180 }}>
              <SelectEscuelasItem
                placeholder="Filtrar por escuela"
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                value={this.state.escuelaFiltro}
                onChange={this.cambiarEscuela}
                allowClear
              />
            </div>
            <div style={{ flex: 1, minWidth: 180 }}>
              <SelectGruposEscuelaItem
                placeholder="Filtrar por grupo"
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                escuelaId={this.state.escuelaFiltro}
                value={this.state.grupoFiltro}
                onChange={this.cambiarGrupo}
                allowClear
              />
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <SegmentedItem
              options={[
                { label: "Activo", value: 1 },
                { label: "Deshabilitado", value: 2 },
                { label: "Todos", value: 3 },
              ]}
              onChange={(value) => {
                if (this.tableRef)
                  this.tableRef.updateExternalFilters({ valor: value });
                this.setState({ valor: value });
              }}
              value={this.state.valor}
            />
            {this.props.permisoImportarAgregarAlumnos && (
              <>
                <ButtonItem
                  type="default"
                  className="botonAgregar"
                  icon={<ImportOutlined />}
                  onClick={() => this.props.history.push("/panel/importarAlumnos")}
                >
                  Importar Alumnos
                </ButtonItem>
                <ButtonItem
                  type="default"
                  className="botonAgregar"
                  icon={<FileTextOutlined />}
                  onClick={() => this.props.history.push("/panel/generarFichasPago")}
                >
                  Generar Fichas de Pago
                </ButtonItem>
                <ButtonItem
                  type="default"
                  className="botonAgregar"
                  lila
                  icon={<UsergroupAddOutlined />}
                  onClick={this.abrirModalLista}
                >
                  Asignar Lista a Alumnos
                  {this.state.seleccionClienteIds.length > 0
                    ? ` (${this.state.seleccionClienteIds.length})`
                    : ""}
                </ButtonItem>
                <ButtonItem
                  type="primary"
                  olivo
                  className="botonAgregar"
                  onClick={() => this.setState({ modalVisible: true })}
                >
                  Agregar Alumno
                </ButtonItem>
              </>
            )}
          </div>
        </div>

        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarAlumnos}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todosAlumnos}
          rowSelection={{
            selectedRowKeys: this.state.seleccionClienteIds,
            onChange: (keys) => this.setState({ seleccionClienteIds: keys }),
          }}
          columns={columns}
          onRow={(record) => ({
            onDoubleClick: () =>
              this.props.history.push("/panel/editarCliente", {
                id: record._id,
              }),
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
          filterStorageKey={"alumnosFiltrosTabla" + this.props.empresaId}
        />

        <AlumnoModal
          visible={this.state.modalVisible}
          cerrarModal={this.cerrarModal}
        />

        <Modal
          title="Asignar Lista a Alumnos"
          visible={this.state.modalListaVisible}
          onCancel={this.cerrarModalLista}
          width={480}
          footer={[
            <ButtonItem key="cancelar" onClick={this.cerrarModalLista}>
              Cancelar
            </ButtonItem>,
            <ButtonItem
              key="asignar"
              type="primary"
              olivo
              disabled={!this.state.listaSeleccionadaId}
              loading={this.state.asignandoLista}
              onClick={this.confirmarAsignarListaMasiva}
            >
              Asignar
            </ButtonItem>,
          ]}
          destroyOnClose
        >
          <Alert
            type="warning"
            showIcon
            message={`Se asignará como lista individual a ${this.state.seleccionClienteIds.length} alumno(s) seleccionado(s), sobrescribiendo la que ya tuvieran.`}
            style={{ marginBottom: 16 }}
          />
          <div>
            <div style={{ marginBottom: 4, fontWeight: 500 }}>Lista a asignar</div>
            <SelectListasEscuelaItem
              placeholder="Selecciona la lista"
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
              value={this.state.listaSeleccionadaId}
              onChange={(listaId, lista) =>
                this.setState({
                  listaSeleccionadaId: listaId,
                  listaSeleccionadaNombre: lista?.nombre || "",
                })
              }
              style={{ width: "100%" }}
            />
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoImportarAgregarAlumnos:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3cc189586391440574cf"
    )?.activado,
  permisoDeshabilitarAlumno:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3cd989586391440574d2"
    )?.activado,
});

export default withRouter(connect(mapStateToProps)(AlumnosTab));
